import { Fragment, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';

import { PanelControls } from '~/components/ui/PanelControls';
import { rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import { Head } from '../../components/Head';
import { MenuTabs } from '../../components/MenuTabs';
import { Modal } from '../../components/Modal';
import { Saved } from '../../components/Saved';
import { Settings } from '../../components/Settings';
import { useModal } from '../../hooks';
import {
	resetStore,
	showSaveModal,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledContainer,
	StyledControlsContainer,
	StyledMenuTabsContainer,
} from './Handling.styled';

const tabs = [Settings, Saved];

const Handling = () => {
	const dispatch = useLayoutDispatch();
	const tabIndex = useLayoutSelector((state) => state.handling.tabIndex);
	const modalVisible = useLayoutSelector(
		(state) => state.handling.modalVisible,
	);
	const saveSelectedIndex = useLayoutSelector(
		(state) => state.handlingList.saveSelectedIndex,
	);
	const presetList = useLayoutSelector(
		(state) => state.handlingList.savePresetList,
	);
	const saveAbsoluteIndex = useLayoutSelector(
		(state) => state.handlingList.saveAbsoluteIndex,
	);

	const {
		handleSetupNewPresetModal,
		handleSetupSaveModal,
		handleUnsavedChangesExitModal,
	} = useModal();

	useEffectOnce(() => {
		rage.handlingTuning
			.fetchValues()
			.catch((err) => rage.notifications.showException(err));

		return () => {
			dispatch(resetStore());
		};
	});

	const saveTabControls = useMemo(
		() =>
			saveSelectedIndex || saveSelectedIndex === 0
				? [
						{
							text: 'Установить',
							keys: ['Enter'],
							onClick: handleSetupSaveModal,
						},
						{
							text: 'В избранное',
							keys: ['V'],
							onClick: () => {
								if (presetList.length !== 0) {
									rage.handlingTuning
										.setPresetFavorite(
											saveAbsoluteIndex,
											!presetList[saveAbsoluteIndex].favorite,
										)
										.catch((err) => rage.notifications.showException(err));
								}
							},
						},
				  ]
				: [
						{
							text: 'Управление',
							keys: ['ArrowUp', 'ArrowDown'],
						},
						{
							text: 'Установить',
							keys: ['Enter'],
							onClick: handleSetupSaveModal,
						},
						{
							text: 'В избранное',
							keys: ['V'],
							onClick: () => {
								if (presetList.length !== 0) {
									rage.handlingTuning
										.setPresetFavorite(
											saveAbsoluteIndex,
											!presetList[saveAbsoluteIndex].favorite,
										)
										.catch((err) => rage.notifications.showException(err));
								}
							},
						},
				  ],
		[saveSelectedIndex, handleSetupSaveModal, presetList, saveAbsoluteIndex],
	);

	const ActiveTab = tabs[tabIndex];

	const controls = [
		[
			{
				text: 'Применить',
				keys: ['Enter'],
				onClick: handleSetupNewPresetModal,
			},
			{
				text: 'Сохранить',
				keys: ['S'],
				onClick: () => {
					dispatch(showSaveModal());
				},
			},
		],
		[...saveTabControls],
	];

	useInputAction(InputAction.CommonMenuClose, handleUnsavedChangesExitModal);
	useInputAction(
		InputAction.HandlingPanelInteract,
		handleUnsavedChangesExitModal,
	);

	return (
		<Fragment>
			<StyledContainer>
				<Head />
				<StyledMenuTabsContainer>
					<MenuTabs />
				</StyledMenuTabsContainer>
				<ActiveTab />
				<StyledControlsContainer>
					<PanelControls controls={controls[tabIndex]} />
				</StyledControlsContainer>
			</StyledContainer>
			<CSSTransition
				in={modalVisible}
				classNames={'modal'}
				timeout={500}
				unmountOnExit
			>
				<Modal />
			</CSSTransition>
		</Fragment>
	);
};

export { Handling };
